import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        applicationFee: [
          !_.isNil(entity.parameters.applicationFee)
            ? entity.parameters.applicationFee
            : null,
          [Validators.required],
        ],
        smoothingFeesDuration: [
          entity.parameters.smoothingFeesDuration != null
            ? entity.parameters.smoothingFeesDuration
            : 'AUCUN',
          [Validators.required],
        ],
        commDerogCode: [
          entity.parameters.commDerogCode != null
            ? entity.parameters.commDerogCode
            : 'L20',
          [Validators.required],
        ],
        premiumType: [
          !!entity?.parameters?.guarantees?.length &&
          !!entity?.parameters?.guarantees?.[0]?.premiumType
            ? entity?.parameters?.guarantees?.[0]?.premiumType
            : 'CI',
          [Validators.required],
        ],
        guarantees: [entity?.parameters?.guarantees || []],
        choosedProductCode: [
          entity?.parameters?.choosedProductCode || null,
          [Validators.required],
        ],
        tarifications: this.formBuilder.array(
          entity?.parameters?.tarifications &&
            entity?.parameters?.tarifications.length
            ? entity?.parameters?.tarifications.map(tarification =>
                this.formBuilder.group({
                  insurerReference: [tarification.insurerReference || null],
                  coutTotal: [tarification.coutTotal || null],
                  mensualite: [tarification.mensualite || null],
                  coutSur8Ans: [tarification.coutSur8Ans || null],
                  tma: [tarification.tma || null],
                  product: this.formBuilder.group({
                    code: [tarification.product.code || null],
                    logo: [tarification.product.logo || null],
                    enabled: [tarification.product.enabled || null],
                    mandatoryFields: this.formBuilder.array(
                      tarification.product.mandatoryFields &&
                        tarification.product.mandatoryFields.length
                        ? tarification.product.mandatoryFields.map(
                            mandatoryField =>
                              this.formBuilder.group({
                                field: [mandatoryField.field || null],
                                mapped: [mandatoryField.mapped || null],
                              }),
                          )
                        : [],
                    ),
                    keyPoints: this.formBuilder.array(
                      tarification.product.keyPoints &&
                        tarification.product.keyPoints.length
                        ? tarification.product.keyPoints.map(keyPoint =>
                            this.formBuilder.group({
                              title: [keyPoint.title || null],
                              content: [keyPoint.content || null],
                            }),
                          )
                        : [],
                    ),
                    occupationRisk: this.formBuilder.array(
                      tarification.product.occupationRisk &&
                        tarification.product.occupationRisk.length
                        ? tarification.product.occupationRisk.map(
                            occupationRisk =>
                              this.formBuilder.group({
                                id: [occupationRisk.id || null],
                                value: [occupationRisk.value || null],
                              }),
                          )
                        : [],
                    ),
                    sportRisk: this.formBuilder.array(
                      tarification.product.sportRisk &&
                        tarification.product.sportRisk.length
                        ? tarification.product.sportRisk.map(sportRisk =>
                            this.formBuilder.group({
                              id: [sportRisk.id || null],
                              value: [sportRisk.value || null],
                            }),
                          )
                        : [],
                    ),
                  }),
                }),
              )
            : [],
        ),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    const products = _.cloneDeep(this.form.value.products);

    products.forEach(product => {
      product.parameters.smoothingFeesDuration =
        product.parameters.smoothingFeesDuration === 'AUCUN'
          ? null
          : product.parameters.smoothingFeesDuration;
      product.parameters.guarantees.forEach(guarantee => {
        guarantee.premiumType = product.parameters.premiumType || 'CI';
      });
      delete product.parameters.premiumType;
    });

    return products;
  }
}
